export * from "./patient-info.component";
export * from "./prime-insurance/prime-insurance.component";
export * from "./basic-info/basic-info.component";
export * from "./allergies/allergies.component";
export * from "./notes/notes.component";
export * from "./pricing/pricing.component";
export * from "./other-info/other-info.component";
export * from "./diag-add/diag-add.component";
